import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";

export const Li = ({pagina, submenu, icono}) => {
    return (
        <li className="items-center">
            <Link
                className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf(`${pagina}`) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                }
                to={pagina}
            >
                <i
                    className={
                        `${icono} mr-2 text-sm ` +
                        (window.location.href.indexOf(`${pagina}`) !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                    }
                ></i>{" "}
                {submenu}
                {/* Divider */}
                <hr className="my-4 md:min-w-full"/>
            </Link>
        </li>
    );
};

Li.prototype = {
    pagina: PropTypes.string,
    submenu: PropTypes.string,
    icono: PropTypes.string
}


